import { ReactNode } from 'react'
import { parseTheme } from 'app/lib/parseConfigTheme'

const LAYOUT_CLASS = 'flex flex-col justify-between min-h-[100dvh] overflow-x-hidden w-full'

export default function Content({ children, config }: { children: ReactNode; config?: IDomainConfig | null }) {
    const layoutSize = config?.theme ? parseTheme(config.theme)?.branding?.layout_size : undefined
    const compactClass = layoutSize === 'compact' ? 'max-full mx-auto' : ''

    return <div className={`${LAYOUT_CLASS} ${compactClass}`.trim()}>{children}</div>
}
